import React, { useState, useRef, useEffect } from 'react';

import DynamicTable from "../components/DynamicTable";
import DocumentModal from "../components/DocumentModal";
import DocumentUpdateAllModal from "../components/DocumentUpdateAllModal";
import TopBar from "../components/TopBar";
import { get_documents, delete_document, update_document, get_watchlists } from '../api/api';
import { toast } from 'react-toastify';
import icon_refresh_orange from '../img/icon_refresh_orange.png';

//import TopBar from "../components/TopBar";

const MainPage = () => {

  const [items, setItems] = useState([]);
  const [teams, setTeams] = useState([]);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isUpdateAllModalOpen, setUpdateAllModalOpen] = useState(false);
  const modalRef = useRef();
  const updateAllModalRef = useRef();

  const openAndResetModal = () => {
    setModalOpen(true);
    setTimeout(() => {
      modalRef.current?.reset(); // ensure reset happens *after* modal is mounted
    }, 0);
  };


  const openAndResetUpdateAllModal = () => {
    setUpdateAllModalOpen(true);
    setTimeout(() => {
      updateAllModalRef.current?.setup(items); // ensure reset happens *after* modal is mounted
    }, 0);
  };




  const getColumDefs = (startEditing, stopEditing, setRecordToDelete, goToDetail) => {
    return [
      { field: "name",
        headerName: "Nome documento",
      },
      { field: "revision",
        headerName: "Rev.",
        width:100
      },
      { field: "typology",
        headerName: "Tipologia",
      },
      { field: "description",
        headerName: "Descrizione",
        flex: 1
      },
      { field: "document_date",
        headerName: "Data creazione",
      },
      { field: "document_modified_date",
        headerName: "Data ultima modifica",
      },
      { field: "username",
        headerName: "Creatore doc",
      },
      { field: "status",
        headerName: "Status",
        valueFormatter: ({ value }) => {
          switch (value) {
            case "done":
              return "Completato";
            case "error":
              return "In errore";
            case "in_progress":
              return "In corso";
            default:
              return value;

      }}}
    ];
  };



  const updateGrid = async () => {

      const get_the_teams = async () => {
          const res = await get_watchlists();
          console.log(res);
          const data = res && res.data && res.data.results ? res.data.results : [];
          // HERE: this works just fine
          console.log(data);
          setTeams(data);     // Set state with resolved data
      };


      const get_the_documents = async () => {
          const res = await get_documents();
          console.log(res);
          const data = res && res.data && res.data.results ? res.data.results : [];
          // HERE: this works just fine
          console.log(data);
          setItems(data);     // Set state with resolved data
      };

      await get_the_teams();
      await get_the_documents();
  }


  useEffect(() => {
      updateGrid();
  }, []);

  const role = localStorage.getItem('role');

  const canAdd = (role === 'Intermediate') || role === 'Advanced' || role === 'Admin';
  const canEdit = role === 'Advanced' || role === 'Admin';



  const onAdd = ()=>{
    openAndResetModal();
  }

  const onUpdateAll = ()=>{
    openAndResetUpdateAllModal();
  }

  const updateDocument = async(id, data) => {

    await update_document(id, data);
    toast.success("Richiesta caricata con successo. Il PDF è in fase di generazione. Riceverai una notifica al completamento dell'operazione.");
    updateGrid();
  }

  return (

    <div>
      <TopBar  />

      <div className="content">



        <div className="main-content">
              {/*<NoItemsFound start_creating={start_creating} visible={items.length === 0 ? "block" : "none"} />*/}

              <div className="dynamic-table-topbar-right">
                <div className="titolo-main">
                  Lista Documenti


                </div>
                <div>
                  { canAdd && (
                    <div>
                      <button className="dynamic-table-refresh" onClick={()=>{toast.success("Aggiornamento tabella completato"); updateGrid()}}>
                        <img src={icon_refresh_orange} alt="refresh" />
                      </button>
                      <button className="dynamic-table-update" onClick={()=>{onUpdateAll()}}>
                        Aggiorna
                      </button>
                      <button className="dynamic-table-add-new" onClick={()=>{onAdd()}}>
                        Aggiungi
                      </button>
                    </div>
                  )}
                </div>

              </div>


              <div className="dynamic-table-outer" style={{ display: (false && items.length === 0 ? "none" : "flex")}}>



                <DynamicTable
                  items={items}
                  getColumnDefs={getColumDefs}
                  deleteFunction={delete_document}
                  updateFunction={updateDocument}
                  updateGrid={updateGrid}
                  showDownloadButtons={true}
                  disableButtonsWhenCreating={true}
                />


                <DocumentModal ref={modalRef} teams={teams} setTeams={setTeams} isOpen={isModalOpen} onClose={()=>{updateGrid(); setModalOpen(false)}}/>
                <DocumentUpdateAllModal ref={updateAllModalRef} isOpen={isUpdateAllModalOpen} onClose={()=>{updateGrid(); setUpdateAllModalOpen(false)}}/>



              </div>


        </div>

      </div>
    </div>


  );
};

export default MainPage;
